/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_ScrollInputs */

const en_hero_scroll = /** @type {(inputs: Hero_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll to travel`)
};

/**
* | output |
* | --- |
* | "Scroll to travel" |
*
* @param {Hero_ScrollInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_scroll = /** @type {((inputs?: Hero_ScrollInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_ScrollInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_scroll(inputs)
});